import { Box, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import YearPicker from "react-year-picker";
// import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import "./ExperienceAndEducation.css";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
const swalWithBootstrapButtons = Swal.mixin({
  customclassName: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});

const ExperienceAndEducation = ({ currentUser, userData, api }) => {
  const params = useParams();
  const [exps, setExp] = useState([]);
  const [edus, setEdu] = useState([]);
  const [experiencesEdit, showExperiencesEdit] = useState(false);
  const [educationsEdit, showEducationsEdit] = useState(false);
  useEffect(() => {
    setExp(userData?.workExperiences);
    setEdu(userData?.educations);
    console.log(
      "firstly>>>>>>>>>>>>>>>>>>",
      userData?.workExperiences,
      userData?.educations,
      userData
    );
  }, [userData]);
  /*****   education portion */
  const [eduErrors, setEduErrors] = useState([]);
  const [expErrors, setExpErrors] = useState([]);
  const educationTemplate = {
    title: "",
    institution: "",
    startYear: "",
    endYear: "",
  };
  const [educations, setEducations] = useState([]);
  const addEducation = () => {
    setEducations([...educations, educationTemplate]);
  };

  const onChangeForEdu = (e, idx) => {
    console.log("running onchange");
    console.log("index:", idx);
    console.log("e.target.value:", e.target.value);
    const updatedEducations = educations.map((edu, i) =>
      i == idx ? Object.assign(edu, { [e.target.name]: e.target.value }) : edu
    );
    setEducations(updatedEducations);
    console.log("updatedEducations>> ", updatedEducations);
  };
  const handleEduStartYear = (date, idx) => {
    console.log("testing ............", typeof date);
    let e = {
      target: {
        name: "startYear",
        value: date,
      },
    };
    onChangeForEdu(e, idx);
  };
  const handleEduEndYear = (date, idx) => {
    let e = {
      target: {
        name: "endYear",
        value: date,
      },
    };
    onChangeForEdu(e, idx);
  };
  const removeEducation = (idx) => {
    console.log("running remove education");
    const filteredEducations = [...educations];
    filteredEducations.splice(idx, 1);
    setEducations(filteredEducations);
  };
  /*************************************/
  /************ Experience portion */
  const experienceTemplate = {
    title: "",
    firm: "",
    startYear: "",
    endYear: "",
  };
  const [experiences, setExperiences] = useState([]);
  const addExperience = () => {
    setExperiences([...experiences, experienceTemplate]);
  };

  const onChangeForExp = (e, idx) => {
    const updatedExperiences = experiences.map((edu, i) =>
      i == idx ? Object.assign(edu, { [e.target.name]: e.target.value }) : edu
    );
    setExperiences(updatedExperiences);
    console.log("updatedExperiences>> ", updatedExperiences);
  };
  const handleExpStartYear = (date, idx) => {
    let e = {
      target: {
        name: "startYear",
        value: date,
      },
    };
    onChangeForExp(e, idx);
  };
  const handleExpEndYear = (date, idx) => {
    let e = {
      target: {
        name: "endYear",
        value: date,
      },
    };
    onChangeForExp(e, idx);
  };
  const removeExperience = (idx) => {
    console.log("running remove experience");
    const filteredExperiences = [...experiences];
    filteredExperiences.splice(idx, 1);
    setExperiences(filteredExperiences);
  };

  function onlyLettersAndSpaces(str) {
    return /^[A-Za-z\s]*$/.test(str);
  }

  const checkEduErrors = () => {
    let data = educations;
    let errors = [];
    data.forEach((i) => errors.push({}));

    data.map((edu, idx) => {
      if (edu.title.length < 1) {
        Object.assign(errors[idx], { title: "this field must be filled" });
      } else if (!onlyLettersAndSpaces(edu.title)) {
        Object.assign(errors[idx], {
          title: "this field must contain letters only",
        });
      }
      if (edu.institution.length < 1) {
        Object.assign(errors[idx], {
          institution: "this field must be filled",
        });
      } else if (!onlyLettersAndSpaces(edu.institution)) {
        Object.assign(errors[idx], {
          institution: "this field must contain letters only",
        });
      }
      if (edu.startYear.length < 1) {
        Object.assign(errors[idx], { startYear: "this field must be filled" });
      }
      if (edu.endYear > new Date().getUTCFullYear()) {
        Object.assign(errors[idx], { endYear: "enter correct dates" });
      }

      if (edu.endYear.length < 1) {
        Object.assign(errors[idx], { endYear: "this field must be filled" });
      } else if (parseInt(edu.startYear) - parseInt(edu.endYear) > 0) {
        Object.assign(errors[idx], {
          endYear: "end date must be larger than start date",
        });
        console.log(
          "parseInt(edu.startYear) - parseInt(edu.endYear) < 0",
          parseInt(edu.startYear) - parseInt(edu.endYear) < 0
        );
      }
    });
    console.log("edu errors>>>", errors);
    setEduErrors(errors);
    return errors;
  };
  const checkExpErrors = () => {
    let data = experiences;
    let errors = [];
    data.forEach((i) => errors.push({}));

    data.map((edu, idx) => {
      if (edu.title.length < 1) {
        Object.assign(errors[idx], { title: "this field must be filled" });
      } else if (!onlyLettersAndSpaces(edu.title)) {
        Object.assign(errors[idx], {
          title: "this field must contain letters only",
        });
      }
      if (edu.firm.length < 1) {
        Object.assign(errors[idx], {
          firm: "this field must be filled",
        });
      } else if (!onlyLettersAndSpaces(edu.firm)) {
        Object.assign(errors[idx], {
          firm: "this field must contain letters only",
        });
      }
      if (edu.startYear.length < 1) {
        Object.assign(errors[idx], { startYear: "this field must be filled" });
      }
      if (edu.endYear > new Date().getUTCFullYear()) {
        Object.assign(errors[idx], { endYear: "enter correct dates" });
      }
      if (edu.endYear.length < 1) {
        Object.assign(errors[idx], { endYear: "this field must be filled" });
      } else if (parseInt(edu.startYear) - parseInt(edu.endYear) > 0) {
        Object.assign(errors[idx], {
          endYear: "end date must be larger than start date",
        });
        console.log(
          "parseInt(edu.startYear) - parseInt(edu.endYear) < 0",
          parseInt(edu.startYear) - parseInt(edu.endYear) < 0
        );
      }
    });
    console.log("exp errors>>>", errors);
    setExpErrors(errors);
    return errors;
  };
  const saveNewEducations = (e) => {
    console.log("educations", educations);

    e.preventDefault();
    /*** check errors */
    let e1 = checkEduErrors();

    /************** */
    let isErrorFound = false;
    console.log("is errror found >>>>>>>>>>>", isErrorFound);
    e1.map((x) => (Object.keys(x).length > 0 ? (isErrorFound = true) : x));
    console.log("is errror found >>>>>>>>>>>", isErrorFound);

    if (!isErrorFound) {
      //save data here
      console.log("saving educations", educations);
      api
        .post("/auth/complete-profile/educations", { educations })
        .then((res) => {
          console.log("submitting education response", res.data);
          Swal.fire(" Updated Successfully!", "", "success");
          setEdu(res.data?.educations);
        })
        .catch((err) =>
          swalWithBootstrapButtons.fire(
            " Updation Unsuccessful!",
            "Something goes wrong",
            "error"
          )
        );
      window.location.reload();
    }
  };
  const saveNewExperiences = (e) => {
    e.preventDefault();
    /*** check errors */
    let e2 = checkExpErrors();

    /************** */
    let isErrorFound = false;
    console.log("is errror found >>>>>>>>>>>", isErrorFound);
    e2.map((x) => (Object.keys(x).length > 0 ? (isErrorFound = true) : x));
    console.log("is errror found >>>>>>>>>>>", isErrorFound);
    if (!isErrorFound) {
      //save data here
      console.log("saving experiences", experiences);
      api
        .post("/auth/complete-profile/workExperiences", { experiences })
        .then((res) => {
          console.log("submitting work experience response", res.data);
          Swal.fire(" Updated Successfully!", "", "success");
          setExp(res.data?.workExperiences);
        })
        .catch((err) =>
          swalWithBootstrapButtons.fire(
            " Updation Unsuccessful!",
            "Something goes wrong",
            "error"
          )
        );
      window.location.reload();
    }
  };
  useEffect(() => {
    if (userData?.workExperiences?.length > 0) {
      setExperiences([...experiences, userData.workExperiences]);
      let data = experiences;
      userData?.workExperiences.forEach((s) => data.push(s));
      setExperiences(data);
    }
    if (userData?.educations?.length > 0) {
      setEducations([...educations, userData.educations]);
      let data = educations;
      userData?.educations.forEach((s) => data.push(s));
      setEducations(data);
    }
  }, [userData]);
  useEffect(() => {
    console.log("experiences>>>", experiences);
    console.log("educations>>>", educations);
  }, [experiences, educations]);
  return (
    <Box className="experience__and__education">
      <section className="row my-2 p-3">
        <>
          <Box className="row">
            <Box className="col-6">
              <Typography
                className="my-4"
                variant="h6"
                sx={{ fontWeight: "600" }}
              >
                Work Experience:
              </Typography>
            </Box>
            {/* <Box className="col-6">
                <Box
                  className="fa fa-edit edit-icon cursor-pointer"
                  sx={{ color: "fontPrimaryColor.main" }}
                  onClick={() => showExperiencesEdit(!experiencesEdit)}
                ></Box>
              </Box> */}
          </Box>
          {exps?.length > 0 ? (
            <>
              {exps.map((exp, i) => (
                <>
                  <>
                    <Typography
                      variant="p"
                      sx={{ color: "fontPrimaryColor.main" }}
                    >
                      {exp.title}
                    </Typography>
                    <Typography
                      variant="p"
                      sx={{ color: "fontPrimaryColor.main" }}
                    >
                      {exp.firm}
                    </Typography>
                    <Typography
                      variant="p"
                      sx={{ color: "fontPrimaryColor.main" }}
                    >
                      {exp.startYear} - {exp.endYear}
                    </Typography>
                  </>
                  <br />
                  <br />
                </>
              ))}
            </>
          ) : (
            <p>No Experience</p>
          )}
          {!params?.userId && !experiencesEdit && (
            <Box
              className="asc__submit__form__button"
              sx={{ marginLeft: "10px" }}
              onClick={() => showExperiencesEdit(!experiencesEdit)}
            >
              Edit Experience
            </Box>
          )}
        </>

        {experiencesEdit && (
          <>
            <Box>
              <button
                className="asc__submit__form__button"
                onClick={(e) => addExperience()}
              >
                +Add More
              </button>
            </Box>
            {experiences.map((experience, idx) => (
              <Box className="dynamic__subgroup" key={idx}>
                <Box
                  className="delete__subgroup__btn"
                  onClick={() => removeExperience(idx)}
                >
                  {/* <RemoveCircleOutlineIcon /> */}remove
                </Box>
                <Box className="group">
                  <label>Title</label>
                  <input
                    type="text"
                    placeholder="e.g. Full Stack Developer"
                    name="title"
                    onChange={(e) => onChangeForExp(e, idx)}
                    value={experience.title}
                  />
                  {expErrors[idx]?.title && (
                    <p className="error__para">{expErrors[idx].title}</p>
                  )}
                </Box>
                <Box className="group">
                  <label>Firm Name</label>
                  <input
                    type="text"
                    placeholder="e.g. Netsol"
                    name="firm"
                    onChange={(e) => onChangeForExp(e, idx)}
                    value={experience.firm}
                  />
                  {expErrors[idx]?.firm && (
                    <p className="error__para">{expErrors[idx].firm}</p>
                  )}
                </Box>
                <Box className="degree__span__group">
                  <Box className="group">
                    <label>Tenure Start Year</label>
                    <Box>
                      <YearPicker
                        onChange={(val) => handleExpStartYear(val, idx)}
                        name="startYear"
                        value={experience.startYear}
                      />
                    </Box>
                    {expErrors[idx]?.startYear && (
                      <p className="error__para">{expErrors[idx].startYear}</p>
                    )}
                  </Box>
                  <Box className="group">
                    <label>Tenure End Year</label>
                    <Box>
                      <YearPicker
                        onChange={(val) => handleExpEndYear(val, idx)}
                        name="endYear"
                        value={experience.endYear}
                      />
                    </Box>
                    {expErrors[idx]?.endYear && (
                      <p className="error__para">{expErrors[idx].endYear}</p>
                    )}
                  </Box>
                </Box>
                <p>
                  {experience.startYear} - {experience.endYear}
                </p>
              </Box>
            ))}
            <Box>
              <button
                className="asc__submit__form__button"
                onClick={(e) => saveNewExperiences(e)}
              >
                Save
              </button>
            </Box>
            <Box className="col-lg-5 col-md-6 col-12 m-auto mt-3"></Box>
          </>
        )}
      </section>
      <hr />
      <section className="row my-2 p-3">
        <>
          <Box className="row">
            <Box className="col-6">
              <Typography
                className="my-4"
                variant="h6"
                sx={{ fontWeight: "600" }}
              >
                Education History:
              </Typography>
            </Box>
            {/* <Box className="col-6">
                <Box
                  className="fa fa-edit edit-icon cursor-pointer"
                  onClick={() => showEducationsEdit(!educationsEdit)}
                ></Box>
              </Box> */}
          </Box>

          {edus?.length > 0 ? (
            <>
              {edus.map((edu) => (
                <>
                  <>
                    <Typography variant="p" color="fontPrimaryColor.main">
                      {edu?.title}
                    </Typography>
                    <Typography variant="p" color="fontPrimaryColor.main">
                      {edu?.institution}
                    </Typography>
                    <Typography variant="p" color="fontPrimaryColor.main">
                      {edu?.startYear} - {edu?.endYear}
                    </Typography>
                  </>
                  <br />
                  <br />
                </>
              ))}
            </>
          ) : (
            <p>No Education Data Given</p>
          )}
        </>
        {!params?.userId && !educationsEdit && (
          <Box
            className="asc__submit__form__button"
            sx={{ marginLeft: "10px" }}
            onClick={() => showEducationsEdit(!educationsEdit)}
          >
            Edit Education
          </Box>
        )}

        {educationsEdit && (
          <>
            <Box>
              <button
                className="asc__submit__form__button"
                onClick={(e) => addEducation()}
              >
                +Add More
              </button>{" "}
            </Box>
            {educations.map((education, idx) => (
              <Box className="dynamic__subgroup" key={idx}>
                <Box
                  className="delete__subgroup__btn"
                  onClick={() => removeEducation(idx)}
                >
                  {/* <RemoveCircleOutlineIcon /> */}remove
                </Box>

                <Box className="group">
                  <label>Title of Degree</label>
                  <input
                    type="text"
                    placeholder="e.g. BSCS"
                    name="title"
                    onChange={(e) => onChangeForEdu(e, idx)}
                    value={education.title}
                  />
                  {eduErrors[idx]?.title && (
                    <p className="error__para">{eduErrors[idx].title}</p>
                  )}
                </Box>
                <Box className="group">
                  <label>Name of Institution</label>
                  <input
                    type="text"
                    placeholder="e.g. Comsats"
                    name="institution"
                    onChange={(e) => onChangeForEdu(e, idx)}
                    value={education.institution}
                  />
                  {eduErrors[idx]?.institution && (
                    <p className="error__para">{eduErrors[idx].institution}</p>
                  )}
                </Box>
                <Box className="degree__span__group">
                  <Box className="group">
                    <label>Start Year</label>
                    {/* <input type="text" placeholder="2020" /> */}
                    <Box>
                      <YearPicker
                        onChange={(val) => handleEduStartYear(val, idx)}
                        name="startYear"
                        value={education.startYear}
                      />
                    </Box>
                    {eduErrors[idx]?.startYear && (
                      <p className="error__para">{eduErrors[idx].startYear}</p>
                    )}
                  </Box>
                  <Box className="group">
                    <label>End Year</label>
                    {/* <input type="text" placeholder="2022" /> */}
                    <Box>
                      <YearPicker
                        onChange={(val) => handleEduEndYear(val, idx)}
                        name="endYear"
                        value={education.endYear}
                      />
                    </Box>
                    {eduErrors[idx]?.endYear && (
                      <p className="error__para">{eduErrors[idx].endYear}</p>
                    )}
                  </Box>
                  <p>
                    {education.startYear} - {education.endYear}
                  </p>
                </Box>
              </Box>
            ))}
            <Box>
              <button
                className="asc__submit__form__button"
                onClick={(e) => saveNewEducations(e)}
              >
                Save
              </button>
            </Box>
          </>
        )}
      </section>
    </Box>
  );
};

export default ExperienceAndEducation;
